import { render, staticRenderFns } from "./LinkDialog.vue?vue&type=template&id=5f4b2f96&scoped=true&"
import script from "./LinkDialog.vue?vue&type=script&lang=js&"
export * from "./LinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkDialog.vue?vue&type=style&index=0&id=5f4b2f96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b2f96",
  null
  
)

export default component.exports